export const eyewearTranslations = {
  ar: {
    title: 'وصف عدسات',
    prescriptionDate: 'تاريخ الوصفة',
    rightEye: 'العين اليمنى',
    leftEye: 'العين اليسرى',
    sphere: 'الكرة',
    cylinder: 'الأسطوانة',
    axis: 'المحور',
    addition: 'الإضافة',
    centerLight: 'مركز الضوء',
    prism: 'المنشور',
    notes: 'ملاحظات',
    notesPlaceholder: 'أدخل أي ملاحظات إضافية...',
    loadPreviousPrescription: 'تحميل الوصفة السابقة',
    showAdvanced: 'إظهار الحقول المتقدمة',
    hideAdvanced: 'إخفاء الحقول المتقدمة',
  },
  en: {
    title: 'Eyewear Prescription',
    prescriptionDate: 'Prescription Date',
    rightEye: 'Right Eye',
    leftEye: 'Left Eye',
    sphere: '(Sphere)',
    cylinder: '(Cylinder)',
    axis: '(Axis)',
    addition: '(Addition)',
    centerLight: '(Center Light)',
    prism: '(Prism)',
    notes: 'Notes',
    notesPlaceholder: 'Enter any additional notes...',
    loadPreviousPrescription: 'Load Previous Prescription',
    showAdvanced: 'Show Hidden Fields',
    hideAdvanced: 'Hide Hidden Fields',
  },
  fr: {
    title: 'Prescription des Lunettes',
    prescriptionDate: 'Date de la Prescription',
    rightEye: 'Oeil Droit',
    leftEye: 'Oeil Gauche',
    sphere: '(Sphère)',
    cylinder: '(Cylindre)',
    axis: '(Axe)',
    addition: '(Addition)',
    centerLight: '(Centre Lumineux)',
    prism: '(Prism)',
    notes: 'Notes',
    notesPlaceholder: 'Entrez des notes supplémentaires...',
    loadPreviousPrescription: 'Charger la Prescription Précédente',
    showAdvanced: 'Afficher les Champs Cachés',
    hideAdvanced: 'Cacher les Champs Cachés',
  },
}
